import React, {useEffect, useState} from 'react';
import {LOCAL_STORAGE_USER_LOGIN_INFO} from "@app/constants/Common";
import {InternalProcessOptions, MemberInternalProcessOptions} from "@pages/jobpipeline/common/Constant";
import Select from "react-select";
import {stringToOption} from "@app/utils/CommonUtils";
import {requestGetUserList} from "@app/services/UserService";
import {
    CddMeCheckStatusOptions,
    DVTJCUVPipelineTableColumns, JobFindModeOptions,
    SearchPipelineFields
} from "@pages/dvtjcuv/common/Constant";
import {DateUtils} from "@app/utils/DateUtils";
import {cloneDeep} from "lodash";
import {findOneOptionByValue} from "@pages/dvtjcuv/common/PipelineUtil";

export const DVTJCUVPipelineInputMode = {
    Add: 1,
    Edit: 2,
    Search: 3
}

const TimeRangeSelection = {
    Week: {value: 1, label: 'Tuần'},
    Month: {value: 2, label: 'Tháng'}
}

const TimeRangeOptions = Object.values(TimeRangeSelection)

const RefereeHighlightColumns = {
    'user_qualify_uv': {'color_class': 'text-danger'},
    'todo_with_person': {'color_class': 'text-danger'},
    'internal_process': {'color_class': 'text-danger'},
    'cdd_status': {'color_class': 'text-success'},
    'interactive_channel':{'color_class': 'text-success'}
}

const OnlyAdminColumns = [
    'cdd_to_employer_process', 'payment_and_warranty'
]

const DVTJCUVPipelineInputForm = (props) => {
    const [dvtjcuvPipeline, setDVTJCUVPipeline] = useState({});
    const [inputMode, setInputMode] = useState(null)
    const [userLoginInfo, setUserLoginInfo] = useState({});
    const [userSearchOptions, setUserSearchOptions] = useState([]);
    const [disableFields, setDisableFields] = useState([]);
    const [fieldList, setFieldList] = useState([]);

    const {pipeLineInfo, isShow, mode, onClose, cddId, onChangeInputItem} = props

    useEffect(() => {
        setInputMode(mode)
        if (mode === DVTJCUVPipelineInputMode.Search) {
            setFieldList(cloneDeep(SearchPipelineFields))
        } else {
            const fields = cloneDeep(DVTJCUVPipelineTableColumns)
            if (pipeLineInfo.read_only) {
                const displayFields = fields.map(item => {
                    item.editable = false
                    return item
                })
                setFieldList(displayFields)
            } else {
                setFieldList(fields)
            }

        }
    }, [mode, pipeLineInfo])

    const fetchUsers = async () => {
        const res = await requestGetUserList({});
        const userList = res.content.users
        const userOptionList = userList.map(user => {
            return  {value: user.id, label : user.email, id: user.id}
        })

        // userOptionList.splice(0, 0, {value: "", label : "Tất cả users", id: ""})
        setUserSearchOptions([...userOptionList])
    };

    useEffect(() => {
        let loginUser = {}
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            loginUser = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO))
            setUserLoginInfo(loginUser)

            if (mode === DVTJCUVPipelineInputMode.Search) {
                if (loginUser.is_superuser) {
                    fetchUsers()
                } else {
                    setUserSearchOptions(
                        [
                            {value: loginUser.id, label : "Chỉ NL của mình", id: loginUser.id},
                        ]
                    )
                }
            }
        }

    }, [])

    const setPipelineInfoForDisplay = (inputPipeline) => {
        const pipeline = {...inputPipeline}
        pipeline.current_find_job_mode = findOneOptionByValue(JobFindModeOptions, pipeline.current_find_job_mode)
        pipeline.dvtjcuv_find_job_mode = findOneOptionByValue(JobFindModeOptions, pipeline.dvtjcuv_find_job_mode)
        // console.log('pipeline me check status:' + pipeline.cdd_me_check_status)
        pipeline.gp_cdd_process = stringToOption(pipeline.gp_cdd_process, true)
        pipeline.us_qualify_cdd = stringToOption(pipeline.us_qualify_cdd, true)
        pipeline.to_do_w_cdd = stringToOption(pipeline.to_do_w_cdd, true)
        pipeline.gp_emp_process = stringToOption(pipeline.gp_emp_process, false)
        pipeline.invite_send_job_gp_emp_process = stringToOption(pipeline.invite_send_job_gp_emp_process, false)
        pipeline.invite_send_job_todo_w_rec = stringToOption(pipeline.invite_send_job_todo_w_rec, false)
        pipeline.matching_potential = stringToOption(pipeline.matching_potential, false)
        pipeline.cdd_emp_process = stringToOption(pipeline.cdd_emp_process, false)
        pipeline.cdd_emp_fu_needed = stringToOption(pipeline.cdd_emp_fu_needed, true)
        pipeline.payment_and_warranty = stringToOption(pipeline.payment_and_warranty, false)
        pipeline.gd_tt_bh_fu_needed = stringToOption(pipeline.gd_tt_bh_fu_needed, true)
        pipeline.cdd_receiver_me_check_status = stringToOption(pipeline.cdd_receiver_me_check_status, false)
        pipeline.interactive_channel = stringToOption(pipeline.interactive_channel, false)
        pipeline.candidate_receive_request = stringToOption(pipeline.candidate_receive_request, true)
        pipeline.cdd_receiver_category = stringToOption(pipeline.cdd_receiver_category, true)
        setDVTJCUVPipeline({...pipeline})
    }

    useEffect(() => {
        if (pipeLineInfo) {
            setPipelineInfoForDisplay(pipeLineInfo)
            if (pipeLineInfo.fromReferee) {
                setDisableFields([
                    'job_id',
                    'referer_id',
                    'candidate_id',
                    'comment_from_referer',
                    'function',
                    'cdd_receiver_function',
                ])
            } else {
                setDisableFields([
                    'function',
                    'cdd_receiver_function',
                ])
            }
        } else {
            setDVTJCUVPipeline({})
        }

        // if (mode === DVTJCUVPipelineInputMode.Add || mode === DVTJCUVPipelineInputMode.Edit) {
        //     disableFields.push('employer_id')
        //     disableFields.push('employer_name')
        // }

        if (cddId) {
            disableFields.push('cdd_id')
            dvtjcuvPipeline.cdd_id = cddId
            setDVTJCUVPipeline({...dvtjcuvPipeline})
        }
        setDisableFields([...disableFields])

    }, [pipeLineInfo, cddId]);

    const onChangeInput = (values, column) => {
        dvtjcuvPipeline[column.key] = values
        setDVTJCUVPipeline({...dvtjcuvPipeline})
        if (onChangeInputItem) {
            onChangeInputItem(values, column)
        }
    }

    const getItemValues = (column, values) => {
        return values || ""
    }

    const getOptions = (column) => {
        if (column.key === 'internal_process') {
            return userLoginInfo.is_superuser ? InternalProcessOptions : MemberInternalProcessOptions
        }

        return column.options
    }

    const highLightLabel = (column) => {
        if (dvtjcuvPipeline.fromReferee) {
            const refereeHighLight = RefereeHighlightColumns[column.key]
            if (refereeHighLight) {
                return refereeHighLight['color_class']
            }
        }
        return ""
    }

    const addWeekMonthFromCurrentDate = (column) => {
        if (!column.originValue) {
            column.originValue = dvtjcuvPipeline[column.key]
        }

        if (!column.timeRangeSelect) {
            column.timeRangeSelect = TimeRangeSelection.Week
        }

        // Trường hợp clear thông tin input số ngày/tháng => reset lại giá trị ban đầu.
        if (!column.timeRangeNumber) {
            dvtjcuvPipeline[column.key] = column.originValue
        } else {
            const currentDate = new Date();
            const newDate = column.timeRangeSelect.value === TimeRangeSelection.Month.value
                ? DateUtils.addMonths(currentDate, column.timeRangeNumber) : DateUtils.addWeeks(currentDate, column.timeRangeNumber)

            dvtjcuvPipeline[column.key] = newDate.toISOString().slice(0, 10)
        }

        setDVTJCUVPipeline({...dvtjcuvPipeline})

        if (onChangeInputItem) {
            onChangeInputItem(dvtjcuvPipeline[column.key], column)
        }
    }

    const onChangeRangeNumber = (event, column) => {
        column.timeRangeNumber = event.target.value
        setFieldList([...fieldList])
        addWeekMonthFromCurrentDate(column)
    }

    const onChangeRangeOption = (value, column) => {
        column.timeRangeSelect = value
        setFieldList([...fieldList])
        addWeekMonthFromCurrentDate(column)
    }

    const isDisableColumn = (column) => {
        return ((inputMode === DVTJCUVPipelineInputMode.Add
                || inputMode === DVTJCUVPipelineInputMode.Edit) && !column.editable
        ) || disableFields.includes(column.key)
    }

    return (
        <div className='row'>
            {inputMode === DVTJCUVPipelineInputMode.Search &&
            <>
                <div className='col-sm-6'>
                    <div className="form-group">
                        <label className={'w-100'}>Phạm vi search</label>
                        <select className='form-control'
                                name={'inputType'}
                                value={dvtjcuvPipeline.search_scope}
                                onChange={event => onChangeInput(event.target.value, {key: 'search_scope'})}>
                            <option value=''>{"Tất cả các dòng"}</option>
                            <option value={'1'}>{"Loại trừ email mời job"}</option>
                            <option value={'2'}>{"NL mới nhất của cùng 1 cặp Person-Job"}</option>
                        </select>
                    </div>
                </div>
            </>
            }

            {inputMode === DVTJCUVPipelineInputMode.Search &&
            <div className={'col-sm-6'}>
                <label>NL bởi users</label>
                <Select options={userSearchOptions}
                        isMulti
                        placeholder={"Tất cả users"}
                        value={dvtjcuvPipeline.created_user}
                        onChange={values => {
                            onChangeInput(values, {key: 'created_user'});
                        }}
                />
            </div>
            }

            {fieldList.map(column => {
                if ((inputMode === DVTJCUVPipelineInputMode.Add && column.autoAdd)
                    || (inputMode === DVTJCUVPipelineInputMode.Search && !column.searchable)
                    || (inputMode !== DVTJCUVPipelineInputMode.Search && OnlyAdminColumns.includes(column.key) && !userLoginInfo.is_superuser)) {
                    return ""
                }

                if (column.inputType === 'option') {
                    return <div className='col-sm-6' key={`update_job_pipeline_input_item_${column.key}`}>
                        <div className='form-group'>
                            <div style={{width: '100%'}}>
                                <label className={`w-100 ${highLightLabel(column)}`}>{column.label}</label>
                                <Select options={getOptions(column)}
                                        value={getItemValues(column, dvtjcuvPipeline[column.key])}
                                        isDisabled={isDisableColumn(column)}
                                        name={column.key}
                                        isMulti={!!column.isMulti}
                                        onChange={value => {
                                            onChangeInput(value, column);
                                        }}
                                />
                            </div>
                        </div>
                    </div>
                }

                if (column.inputType === 'textarea') {
                    return <div className='col-sm-6' key={`update_job_pipeline_input_item_${column.key}`}>
                        <div className='form-group '>
                            <label className={`w-100 ${highLightLabel(column)}`}>{column.label}</label>
                            <textarea className='form-control'
                                      value={getItemValues(column, dvtjcuvPipeline[column.key])}
                                      name={column.key}
                                      disabled={isDisableColumn(column)}
                                      onChange={event => onChangeInput(event.target.value, column)}/>
                        </div>
                    </div>
                }

                const handleKeyDownNumber = (event) => {
                    if (event.key === "-" || event.keyCode === 189) {
                        event.preventDefault();
                    }
                };

                return <div className='col-sm-6' key={`update_job_pipeline_input_item_${column.key}`}>
                            <div className='form-group'>
                                <label className={'w-100'}>{column.label}</label>
                                <div className={'row'}>
                                    {column.inputRange && inputMode !== DVTJCUVPipelineInputMode.Search &&
                                        <>
                                            <div className='col-sm-4 pr-0'>
                                                <input className='form-control' type={'number'} placeholder={'Nhập số tuần/tháng'}
                                                       value={column?.timeRangeNumber || ''}
                                                       min={'0'}
                                                       disabled={!column.editable}
                                                       onKeyDown={handleKeyDownNumber}
                                                       onChange={event => onChangeRangeNumber(event, column)}
                                                />
                                            </div>
                                            <div className='col-sm-3 pr-0'>
                                                <Select options={TimeRangeOptions}
                                                        value={column.timeRangeSelect || TimeRangeOptions[0]}
                                                        isDisabled={!column.editable}
                                                        onChange={value => {
                                                            onChangeRangeOption(value, column);
                                                        }}
                                                />
                                            </div>
                                        </>
                                    }
                                    <div className={column.inputRange && inputMode !== DVTJCUVPipelineInputMode.Search ? 'col-sm-5' : 'col-sm-12'}>
                                        <input type={column.inputType} className='form-control'
                                               disabled={(inputMode === DVTJCUVPipelineInputMode.Edit && !column.editable) || disableFields.includes(column.key)}
                                               value={getItemValues(column, dvtjcuvPipeline[column.key])}
                                               name={column.key} onChange={event => onChangeInput(event.target.value, column)}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    })}
                </div>
    )
}

export default DVTJCUVPipelineInputForm;
